module.exports = __webpack_public_path__ + "img/80_21.acb0e17a.png";